import { IUserNotificationService } from '@dirootie-web/components-types';
import { useContainer } from './use-container.hook';

export const useNotifications = () => {
  const container = useContainer();
  const notificationService = container.resolve<IUserNotificationService>(
    'user-notification-service'
  );
  return notificationService;
};
